export default __webpack_public_path__ + "static/media/ic_info_user.39fec46e.svg";